import { SignUp } from '@type/api-types';
import { createContext, useContext } from 'react';

export interface PaymentContextValues {
    loading: boolean;
    processEventPayment: (signUps: SignUp[], onError: (msg: string) => void) => Promise<void>;
}

export const PaymentContext = createContext<PaymentContextValues>({
    loading: true,
    processEventPayment: () => Promise.resolve(),
});

// Access user context values and functions
const usePayment = () => {
    const ctx = useContext(PaymentContext);

    if (!ctx) console.error('usePayment called outside of PaymentProvider Context');

    return ctx;
};

export default usePayment;
